import { useEffect } from "react";
// import { useAuth } from "../context/Context";
import { useNavigate } from "react-router-dom";

const Maintenance = () => {
    // const { siteData } = useAuth();
	// const navigate = useNavigate();

    // useEffect(() => {
    //     if(!siteData) return;

    //     if(parseInt(siteData?.is_website_maintenance) === 0){
	// 		navigate('/');
    //     }

    // }, [siteData, navigate])

    const siteData = {};

    return(
        <div className="under-maintenance">
            <div className="container">
                <div className="row h-100 justify-content-center align-items-center">
                    <div className="what-is-up">

                        <div className="spinny-cogs">
                            <i className="fa fa-cog"></i>
                            <i className="fa fa-5x fa-cog fa-spin"></i>
                            <i className="fa fa-3x fa-cog"></i>
                        </div>
                        <h1 className="maintenance-title">{siteData?.title} Will Be Back Soon</h1>
                        <p className="mb-1">We're making some updates to improve your viewing experience.</p>
                        <p>Stay tuned — we'll be live again shortly!</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Maintenance;